import React, { Component } from 'react'
import styles from './index.module.less'
const ReactMarkdown = require('react-markdown/with-html')
import markdown from './markdown'

export default class Content1 extends Component {
  
  render() {
    return (
      <div className={styles.container}>
        <ReactMarkdown source={markdown} escapeHtml={false}></ReactMarkdown>
      </div>
    )
  }
}